export const email = {
  regex: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
  length: {
    max: 100
  }
};

export const password = {
  regex: new RegExp('^(?=.*[A-Z])(?=.*[!@#$%^&*()\\\\\/\\[\\]\\-_=+{}|?>.<,:;~`\'])(?=.*[0-9])(?=.*[a-z]).{8,20}$'),
  length: {
    min: 8,
    max: 20
  }
}

export const user = {
  firstName: {
    regex: new RegExp('^[A-Za-z\\-()\'.,]+(?: [A-Za-z\\-()\'.,]+)*$'),
    length: {
      min: 1,
      max: 50
    },
  },
  lastName: {
    regex: new RegExp('^[A-Za-z\\-()\'.,]+(?: [A-Za-z\\-()\'.,]+)*$'),
    length: {
      min: 1,
      max: 50
    },
  },
  username: {
    regex: new RegExp('^[a-zA-Z]([._-](?![._])|[a-zA-Z0-9])*[a-zA-Z0-9]$'),
    length: {
      min: 2,
      max: 100
    }
  },
  height: {
    length: {
      min: 5,
      max: 50
    }
  },
  weight: {
    length: {
      min: 5,
      max: 50
    }
  },
}

export const address = {
  regex: new RegExp('^[a-zA-Z0-9]([\\s]|[a-zA-Z0-9-/_,.])*[a-zA-Z0-9.]'),
  location: {
    length: {
      min: 1,
      max: 35
    }
  },
  recipientName: {
    length: {
      min: 1,
      max: 20
    }
  },
  addressLine1: {
    length: {
      min: 1,
      max: 250
    }
  },
  addressLine2: {
    length: {
      min: 1,
      max: 250
    }
  },
  zipCode: {
    length: {
      min: 5,
      max: 10
    }
  },
  city: {
    regex: new RegExp(/[A-Za-z]$/),
    length: {
      min: 2,
      max: 50
    }
  },
  state: {
    length: {
      min: 1,
      max: 20
    }
  },
};

export const phoneNumber = {
  length: {
    min: 8,
    max: 18
  }
};

export const notes = {
  length: {
    min: 0,
    max: 500
  }
};

export const client = {
  name: {
    regex: new RegExp(/^(?!\s)([a-zA-Z0-9](?=[a-zA-Z0-9]*[a-zA-Z]){2}[a-zA-Z0-9]*)(?<!\s)$/),
    length: {
      min: 2,
      max: 100
    }
  },
}

export const group = {
  name: {
    regex: new RegExp('^[a-zA-Z0-9_\\-:]+( [a-zA-Z0-9_\\-:]+)*'),
    length: {
      min: 2,
      max: 100
    }
  },
  customBmi: {
    length: {
      min: 1,
      max: 2
    }
  },
  participantAge: {
    length: {
      min: 1,
      max: 2
    }
  }
}

export const addResources = {
  title: {
    length: {
      min: 3,
      max: 50
    }
  },
  description: {
    length: {
      max: 1000
    }
  },
  googleSlides: {
    regex: /<iframe\s+src="(https?:\/\/docs\.google\.com\/presentation\S+)".+><\/iframe>/g
  },
  text: {
    length: {
      min: 1
    }
  }
}

export const onboarding = {
  other: {
    length: {
      min: 1,
      max: 25
    }
  },
  otherPronoun: {
    length: {
      min: 1,
      max: 25
    }
  },
  otherLang: {
    length: {
      min: 1,
      max: 25
    }
  },
  otherInsurance: {
    length: {
      min: 1,
      max: 100
    }
  },
  otp: {
    length: {
      min: 6,
      max: 6
    }
  }
};

export const measurements = {
  height: {
    min: 24,
    max: 96
  },
  weight: {
    min: 50,
    max: 1000,
  },
  bp: {
    regex: '.*\\/.*',
  },
  name: {
    length: {
      min: 2,
      max: 50,
    },
  },
}

export const surveySchedule = {
  title: {
    length: {
      min: 3,
    },
    regex: '^[a-zA-Z][a-zA-Z0-9]*([ ]?[a-zA-Z0-9!@#$%^&*()_+-=<>?/{}[\]|\s]+)*$',
  },
  description: {
    length: {
      min: 3,
    },
    regex: `^[a-zA-Z][a-zA-Z0-9]*([ ]?[a-zA-Z0-9!@#$%^&*()_+-=<>?/{}[\]|\s]+)*$`,
  },
};

export const phiPiiDetails = {
  personInHouse: {
    length: {
      min: 1,
      max: 99
    },
  }
};
